import {filter} from 'rxjs/operators';

function isDefined(value: any): boolean {
	return value !== undefined && value !== null;
}

export function filterDefined<T>() {
	return filter<T>((value: T) => isDefined(value) && (Array.isArray(value) ? value.every(v => isDefined(v)) : true));
}
